import Styles from './Testimonials.module.css'

import type {VisualAsset, TestimonialStat} from '../../../Index.types'

export interface TestimonialsProps {
  items: Array<{
    quote: string
    author: {
      name: string
      position: string
      avatar: VisualAsset
    }
  }>
  stats: [TestimonialStat, TestimonialStat]
}

export const defaultProps: Partial<TestimonialsProps> = {}

export const Testimonials = (props: TestimonialsProps) => {
  const initializedProps: TestimonialsProps = {...defaultProps, ...props}
  // eslint-disable-next-line no-empty-pattern
  const {} = initializedProps

  return <div className={Styles['Testimonials']}>Testimonials</div>
}
